import { MANTY_COLORS } from 'business/constants';
import { RecurrenceEnum } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/constants';

export const AGENT_DEPARTURE_HYPOTHESIS_ID = 'id';
export const AGENT_DEPARTURE_HYPOTHESIS_TYPE = 'agentDepartureHypothesisType';
export const AGENT_DEPARTURE_HYPOTHESIS = 'agentDepartureHypothesis';

export enum AgentDepartureHypothesisType {
    SIMPLE_DEPARTURE = 'simple_departure',
    RETIREMENT_DEPARTURE = 'retirement_departure',
    AVAILABILITY = 'availability',
    ABSENCE = 'absence',
    END_OF_CONTRACT = 'end_of_contract',
}

export const AGENT_DEPARTURE_HYPOTHESIS_TYPES_BY_RECURRENCE = {
    [RecurrenceEnum.RECURRENT]: [
        AgentDepartureHypothesisType.SIMPLE_DEPARTURE,
        AgentDepartureHypothesisType.RETIREMENT_DEPARTURE,
        AgentDepartureHypothesisType.AVAILABILITY,
        AgentDepartureHypothesisType.ABSENCE,
    ],
    [RecurrenceEnum.NON_RECURRENT]: [
        AgentDepartureHypothesisType.END_OF_CONTRACT,
        AgentDepartureHypothesisType.ABSENCE,
        AgentDepartureHypothesisType.SIMPLE_DEPARTURE,
    ],
};

export const AgentDepartureHypothesisTypesColor = {
    [AgentDepartureHypothesisType.SIMPLE_DEPARTURE]: MANTY_COLORS.yellow,
    [AgentDepartureHypothesisType.RETIREMENT_DEPARTURE]: MANTY_COLORS.blue,
    [AgentDepartureHypothesisType.AVAILABILITY]: MANTY_COLORS.green,
    [AgentDepartureHypothesisType.ABSENCE]: MANTY_COLORS.orange,
    [AgentDepartureHypothesisType.END_OF_CONTRACT]: MANTY_COLORS.cyan,
};
